import { makeStyles, IconButton } from '@material-ui/core';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import React, { useEffect, useState } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

const useStyles = makeStyles((theme) => ({
  paginationContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    padding: theme.spacing(1, 1.5),
    boxShadow: '0 0 5px 0 rgba(0,0,0,0.1)',
    borderTop: '2px solid rgba(0,0,0,0.1)',
    borderRadius: '0 0 8px 8px',
  },
  counter: {
    display: 'flex',
    margin: '3px 10px',
    whiteSpace: 'nowrap',
    textAlign: 'center',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  center: {
    flex: '0 1 auto',
    textAlign: 'center',
    marginBottom: 0,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputWrapper: {
    border: '1px solid rgba(0,0,0,0.1)',
    background: theme.palette.background.paper,
    padding: '5px 7px',
    fontSize: 'inherit',
    borderRadius: 6,
    fontWeight: 'normal',
    outlineWidth: 0,
  },
  pageNavButton: {
    padding: theme.spacing(1),
    color: theme.palette.text.secondary,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

const CustomPaginationComponent = ({ page, pages, onPageChange }) => {
  const classes = useStyles();
  const [inputValue, setInputValue] = useState(page + 1);

  useEffect(() => {
    if (pages === 0) {
      setInputValue(page);
    } else {
      setInputValue(page + 1);
    }
  }, [page, pages]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      let newPage = parseInt(inputValue, 10);
      if (!isNaN(newPage) && newPage >= 1 && newPage <= pages) {
        onPageChange(newPage - 1);
      }
      if (newPage > pages) {
        onPageChange(pages - 1);
        setInputValue(pages);
      }

      if (newPage < 1) {
        onPageChange(0);
        setInputValue(1);
      }
    }
  };

  const handleChange = (e) => {
    let input = e.target.valueAsNumber;
    if (Number.isNaN(input)) {
    } else if (input === 0) {
      setInputValue(1);
    } else {
      if (e.target.value > pages) {
        setInputValue(pages);
      } else {
        setInputValue(e.target.value);
      }
    }
  };

  const handleOnBlurChange = (e) => {
    if (e.target.value > pages) {
      setInputValue(pages);
    } else {
      setInputValue(e.target.value);
      onPageChange(e.target.value - 1);
    }
  };

  const handleNextClick = () => {
    const nextPage = page + 1;
    if (nextPage < pages) {
      setInputValue(nextPage + 1);
      onPageChange(nextPage);
    }
  };

  const handlePreviousClick = () => {
    const previousPage = page - 1;
    if (previousPage >= 0) {
      setInputValue(previousPage + 1);
      onPageChange(previousPage);
    }
  };

  const canGoPrev = page > 0 && pages > 0;
  const canGoNext = pages > 0 && page < pages - 1;

  return (
    <div className={classes.paginationContainer}>
      <IconButton
        className={classes.pageNavButton}
        size="small"
        onClick={handlePreviousClick}
        disabled={!canGoPrev}
        aria-label="Pagina precedente"
      >
        <ChevronLeft />
      </IconButton>
      <div className={classes.center}>
        <span className={classes.counter}>
          <div>Pagina</div>
          <div className={classes.inputWrapper}>
            <input
              id="myNumberInput"
              type="number"
              value={inputValue}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              style={{
                width: '70px',
                textAlign: 'center',
                fontSize: '1rem',
              }}
              min={1}
              onBlur={handleOnBlurChange}
            />
          </div>
          <div>di {pages}</div>
        </span>
      </div>
      <IconButton
        className={classes.pageNavButton}
        size="small"
        onClick={handleNextClick}
        disabled={!canGoNext}
        aria-label="Pagina successiva"
      >
        <ChevronRight />
      </IconButton>
    </div>
  );
};

const BasicTable = ({
  data,
  columns,
  defaultPageSize,
  onPageChange,
  pages,
  style,
  page,
  loading,
}) => {
  return (
    <div>
      <ReactTable
        data={data}
        columns={columns}
        sortable={false}
        filterable
        resizable
        defaultPageSize={defaultPageSize}
        pages={pages}
        loading={loading}
        loadingText="Caricamento..."
        manual
        style={style}
        onPageChange={onPageChange}
        page={page}
        getTrProps={(state, rowInfo, column) => {
          return {
            style: {
              background:
                rowInfo !== undefined &&
                rowInfo.row.stato === 'IN ATTESA PAGAMENTO'
                  ? '#fef8a0'
                  : 'white',
            },
          };
        }}
        defaultFilterMethod={(filter, row, _column) => {
          const id = filter.pivotId || filter.id;
          return row[id] !== undefined
            ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase())
            : true;
        }}
        showPageSizeOptions={false}
        PaginationComponent={CustomPaginationComponent}
        noDataText="Nessuna riga trovata"
      />
    </div>
  );
};

export default BasicTable;
